var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ac-draggable',{attrs:{"list":_vm.list}},_vm._l((_vm.list),function(element){return _c('div',{key:element.name,staticClass:"list-group-item"},[_vm._v(_vm._s(element.name))])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }